import React, { useState } from "react";
import Select from "react-select";
import Input from "../../../Input";
import Button from "../../../Button";
import logo from "../../../../resources/bluedot-logo.png";
import * as styled from "./styled";
import * as sharedStyled from "../../styled";

interface LoginFormValidationErrors {
  email?: string;
  password?: string;
  region?: string;
}

export default ({
  handleLogin,
  loginErrorMessage,
}: {
  handleLogin: (email, password, region) => void;
  loginErrorMessage?: string;
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [region, setRegion] = useState(undefined);
  const [validationErrors, setValidationErrors] = useState<
    LoginFormValidationErrors
  >({});

  const canvasRegions = [
    { label: "Asia Pacific", value: "au" },
    { label: "Europe", value: "eu" },
    { label: "North America", value: "us" },
  ];

  const validateForm = () => {
    const newValidationErrors: LoginFormValidationErrors = {};
    if (!email) {
      newValidationErrors.email = "Please enter an email address";
    }
    if (!region) {
      newValidationErrors.region = "Please select a region";
    }
    if (!password) {
      newValidationErrors.password = "Please enter a password";
    }
    if (Object.keys(newValidationErrors).length > 0) {
      setValidationErrors(newValidationErrors);
      return false;
    }
    setValidationErrors({});
    return true;
  };

  const handleLinkButtonClick = async () => {
    if (!validateForm()) {
      return;
    }
    handleLogin(email, password, region.value);
  };

  const handleRegionChange = (selected) => {
    setRegion(selected);
    if (validationErrors.region) {
      const newValidationErrors = {
        ...validationErrors,
      };
      delete newValidationErrors.region;
      setValidationErrors(newValidationErrors);
    }
  };

  return (
    <sharedStyled.Container>
      <div>
        <sharedStyled.MainContentContainer>
          <sharedStyled.Logo src={logo} alt="logo" />
          <styled.FormWrapper>
            <styled.SelectWrapper
              className={validationErrors.region ? "invalid" : undefined}
            >
              <Select
                options={canvasRegions}
                className="region-selector"
                classNamePrefix="region-selector"
                placeholder="Select your region"
                onChange={handleRegionChange}
              />
            </styled.SelectWrapper>
            <styled.SelectErrorWrapper>
              {validationErrors.region && (
                <span className="custom-error">{validationErrors.region}</span>
              )}
            </styled.SelectErrorWrapper>
            <Input
              id="email-input"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="Email Address"
              error={validationErrors.email}
            />
            <Input
              id="password-input"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              type="password"
              placeholder="Password"
              error={validationErrors.password}
            />
            <styled.ErrorWrapper>
              {loginErrorMessage && (
                <span className="custom-error">{loginErrorMessage}</span>
              )}
            </styled.ErrorWrapper>
            <sharedStyled.ButtonsWrapper>
              <Button onClick={handleLinkButtonClick}>
                Link SFMC to Bluedot
              </Button>
            </sharedStyled.ButtonsWrapper>
          </styled.FormWrapper>
        </sharedStyled.MainContentContainer>
        <styled.SupportMessageContainer>
          <p>Need Help?</p>
          <a
            href="https://bluedotinnovation.zendesk.com/hc/en-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact our Support Team
          </a>
        </styled.SupportMessageContainer>
      </div>
    </sharedStyled.Container>
  );
};
